export const REGISTER_USERS_CONNECTED_MODULES_PROFILE = 'REGISTER_USERS_CONNECTED_MODULES_PROFILE'
export const PROFILE_USER_UPDATE = 'PROFILE_USER_UPDATE'
export const LOADING_PROFILE_USER_UPDATE = 'LOADING_PROFILE_USER_UPDATE'